module.exports = __webpack_public_path__ + "img/123.38eabfb1.jpg";